<div class="store-not-found">
  <img class="mascot" src="assets/generalImage/not_found.svg" alt="mascot">

  <p class="not-found-description">{{"merchant.search.no.result" | translate}}</p>

  <app-button [textButton]="true" [buttonName]="'button.back.to.home'"
    (onClickEvent)="goBackToPreviousPage()"></app-button>

  <span *ngIf="errorCode" class="errorCode">{{ 'error.code' | translate: {code : errorCode} }}</span>
</div>